<div class="table-header table-header-offset table-header-with-controls mt-5">
  <div class="table-header-controls no-title">
    <div class="table-header-search">
      <rkt-table-search (changed)="onSearch($event)" placeholder="Search by Txn ID" />
    </div>

    <div class="list-filters">
      <button type="button" appRemoveFocus class="table-header-filter-btn" (click)="filterMenu.toggle($event)" #filterBtn>
        <rkt-icon name="filter" class="table-header-filter-icon" />
        Filter
        @if (activeFiltersCount$ | async) {
          <span class="table-header-filter-counter">{{ activeFiltersCount$ | async }}</span>
        }
      </button>
    </div>
  </div>
</div>

<div class="users-list">
  <rkt-table
    [rows]="(transactions$ | async) || []"
    [columns]="columns"
    [count]="(totalElements$ | async)!"
    [loadingIndicator]="(isLoading$ | async)!"
    [offset]="activePage"
    (fetchData)="getTransactions($event)"
    [messages]="{ emptyMessage: emptyListMessage }"
    emptyValuePlaceholder="--"
    dateTimeFormat="MM/dd/yy HH:mm"
    [sortParam]="sortParams"
    [rowHeight]="64"
    [isItemsAlignCenter]="true"
    (rowActivated)="router.navigate(['app', 'transactions', $event.id, 'details'])"
  />
</div>

<app-filter-menu
  #filterMenu
  [initialValues]="(activeFilters$ | async) || {}"
  [filters]="filters"
  (opened)="filterBtn.classList.add('opened')"
  (closed)="filterBtn.classList.remove('opened')"
  (saved)="applyFilters($event)"
/>
